function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}

function randomFloat(min, max) {
  return Math.random() * (max - min) + min;
}

let paperInitialized = false;
let controls, canvas;
let hasFired = false;
const CANVAS_WIDTH = 500, CANVAS_HEIGHT = 500;

function setupPaperCanvas() {
  if (paperInitialized) return;
  paperInitialized = true;

  canvas = document.createElement("canvas");
  canvas.width = CANVAS_WIDTH;
  canvas.height = CANVAS_HEIGHT;
  canvas.style.position = 'fixed';
  canvas.style.left = '85%';
  canvas.style.top = '30%';
  canvas.style.transform = 'translate(-50%, -50%)';
   canvas.style.zIndex = '2147483647';
  canvas.style.pointerEvents = 'none';
  document.body.appendChild(canvas);

  paper.setup(canvas);

  new paper.Path.Rectangle(new paper.Point(0, 0), new paper.Size(CANVAS_WIDTH, CANVAS_HEIGHT)).fillColor = 'rgba(0,0,0,0)';

  controls = {
    size: { value: 1 },
    rotation: { value: 3 },
    spread: { value: 2 },
    frequency: { value: 5 },
    flicker: { value: 5 },
    velocity: { value: 5 },
    drag: { value: 1 },
  };

  let confetti = [];
  let nextConfetti = 0;

  function Confet() {
    this.display = new paper.Path.Rectangle(
      new paper.Point(CANVAS_WIDTH / 2 + randomInt(-10, 10), CANVAS_HEIGHT),
      new paper.Size(7 * controls.size.value, 10 * controls.size.value)
    );
    this.display.rotation = randomInt(0, 360);
    this.display.fillColor = [
      '#4171ec', 
      '#a1c96d', 
      '#7dd4bf',
      '#4dc898', 
      '#ff3b3f', 
      '#ff8c00', 
      '#ffd700',
      '#ba55d3', 
      '#ff69b4', 
      '#00ced1'  
    ][randomInt(0, 10)];  

    this.display.data = {
      vx: randomFloat(-controls.spread.value, controls.spread.value),
      vy: randomFloat(-3, -controls.velocity.value - 3),
      vrot: randomFloat(-controls.rotation.value, controls.rotation.value),
      spinTiming: randomInt(20, controls.flicker.value + 30),
      endvy: randomFloat(controls.drag.value - 0.2, controls.drag.value),
    };

    this.display.onFrame = function (e) {
      this.fillColor.brightness = (e.count % this.data.spinTiming > this.data.spinTiming / 2) ? 0.7 : 0.5;
      this.rotation += this.data.vrot;
      this.position.x += this.data.vx;
      this.position.y += this.data.vy;
      this.data.vy = Math.min(this.data.endvy, this.data.vy + 0.09);
      this.data.vx *= 0.992;
      if (this.position.y > CANVAS_HEIGHT + 20) {
        this.remove();
      }
    };
  }

  paper.view.onFrame = function () {
    if (nextConfetti < 0) {
      confetti.push(new Confet());
      nextConfetti = randomInt(0, controls.frequency.value);
    }
    nextConfetti--;
  };
}

function triggerCanvasConfetti() {
  if (hasFired) return;
  hasFired = true;
  setupPaperCanvas();

  setTimeout(() => {
    if (canvas) {
      paper.view.onFrame = null; 
      canvas.remove();
      paperInitialized = false;
      hasFired = false; 
    }
  }, 3000); 
}

function checkClassChange(mutation) {
  const el = mutation.target;
  const oldClass = mutation.oldValue || '';
  const becameActive = oldClass.includes('op_inactive') && el.classList.contains('op_active');
  const hasTargetClasses = el.classList.contains('cd-icon-reward-2') && el.classList.contains('icon-0');

  if (becameActive && hasTargetClasses && !hasFired) {
    console.log('Bắn pháo hoa');
    triggerCanvasConfetti();
  }
}

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      checkClassChange(mutation);
    }
  }
});

window.addEventListener('OpusCartChange', () => {
  document.querySelectorAll('.cd-icon-reward-2.icon-0').forEach((el) => {
    observer.observe(el, { attributes: true, attributeOldValue: true });
  });
});
